import { CommonColors } from "../../../types/colors";
import { MaterialCardDescriptionColors } from "./types";

export const descriptionStyles: Record<MaterialCardDescriptionColors, string> = {
  [CommonColors.Primary]: "text-primary",
  [CommonColors.Light]: "text-light",
  [CommonColors.Dark]: "text-dark",
};
